import { PublicClientApplication } from "@azure/msal-browser";
import { MS_CLIENT_ID, MS_TENANT_ID } from "./constants";

export const msalEnabled = !!MS_CLIENT_ID;

export const msalInstance = msalEnabled
  ? new PublicClientApplication({
      auth: {
        clientId: MS_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${MS_TENANT_ID}`,
        redirectUri: window.location.origin,
      },
    })
  : undefined;

let initialized: Promise<void> | undefined;

export function ensureMsalInitialized(): Promise<void> {
  if (!msalInstance) return Promise.resolve();
  if (!initialized) initialized = msalInstance.initialize();
  return initialized;
}
